import { forwardRef } from 'react'
import cx from 'classnames'

type Props = {
  className?: string
  children?: React.ReactNode
}

const TemplatesConfigPanelMain = forwardRef<HTMLDivElement, Props>(
  ({ className, children }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(
          'flex overflow-y-auto overflow-x-hidden flex-1',
          className
        )}
      >
        {children}
      </div>
    )
  }
)

export default TemplatesConfigPanelMain
